export default __webpack_public_path__ + "static/media/empresa4.0eeb81b9.png";